<template>
    <div v-if="json" class="social-links">
        <template v-for="(socialItem, index) in json.config.social[0]">
            <div v-if="socialItem" :key="`social${index}`" :class="`socicon-holder ${index}`">
                <!-- Iterate over each social media platform (e.g., facebook, instagram) -->
                <a

                    :key="`link-${index}`"
                    :class="`socicon-a zlink-underline-leftright-${themeColor} ${index}`"
                    :href="socialItem.url"
                    target="_blank"
                >
                    <!-- Load SVG based on platform name -->
                    <inline-svg :src="getSvgPath(index)" class="icon-svg"></inline-svg>
                </a>
            </div>
        </template>
    </div>
</template>

<script>
export default {
    name: "SocialComponent",
    props: {
        themeColor: {
            type: String,
            required: false,
            default: 'gray',
        },
    },
    data() {
        return {
            window: window,
            json: null,
        };
    },
    mounted() {
        // Assuming the json comes from global config
        this.json = this.window.config.json.global;
    },
    methods: {
        // Method to dynamically return the SVG file path based on the social media platform (e.g., facebook, instagram)
        getSvgPath(platform) {
            // Assuming SVG files are stored in /assets/site/images/ folder
            return `/assets/site/images/social-${platform}.svg`;
        },
    },
};
</script>
